import { styled, css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  align-items: flex-start;
  background: white;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  width: 100%;

  .input {
    flex: 1;

    input {
      margin: 0;
    }
  }
`;

export const GridContent = styled.div`
  box-sizing: border-box;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));
  grid-template-rows: 0fr 0fr;
  justify-items: center;
  min-height: 60svh;
  width: 100%;

  label {
    min-height: unset;
    padding: unset;

    input {
      float: unset !important;
      margin: unset !important;
    }
  }

  .disabled-mediacard {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;

    &:hover {
      opacity: 0.4;
    }
  }
`;

export const FlexContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 60svh;
`;

export const FlexContentCanva = styled(FlexContent)`
  align-items: flex-start;
  min-height: 44.4svh;
  padding-top: 1rem;
`;

export const BlankStateContainer = styled.div`
  ${({ theme: { colors, fontSizes } }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 60svh;
    width: 100%;

    p {
      color: ${colors.brandDark};
      font-size: ${fontSizes.s16};
      margin: 0;
    }
  `}
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const FooterContent = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  width: 100%;
`;

export const SelectionCount = styled.span`
  color: #666;
  font-size: 0.875rem;
`;

export const ConnectService = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0;
  width: 100%;
`;

export const GoogleDriveCenter = styled.div`
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CanvaButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  padding: 1.25rem;
  width: 100%;

  h1 {
    margin-bottom: 1rem;
  }
  button {
    width: 13.4rem;
    justify-content: flex-start;
    border-radius: 0.25rem;
    display: flex;
    padding: 0.625rem 1rem;
    align-items: center;
    gap: 0.5rem;
  }
`;
